import { from } from 'rxjs';
import httpClient from '../app/http-clients/http-client';
import { SystemHelpers } from '../app/helpers';

export const receiptsGet = () => from(httpClient.get(`/receipts/${SystemHelpers.getCachedUserId()}`));
